import api from "../../api";

/**
 * {
  "Content": "Hola esto es un comentario de prueba",
  "ObjectId": 4,
  "ObjectTable": "Messages",
  "CreatedByUserId": 130,
  "UpdatedByUserId": 130,
  "CreatedAt": "2020-08-28T18:47:40.351Z",
  "LastUpdatedAt": "2020-08-28T18:47:40.351Z",
}
 */

const state = {
  status: "",
  list: [],
  db_comments: {}
};

const getters = {
  isLoading: (state) => state.status === "loading",
  getComments: (state) => (object_id) => state.db_comments[object_id]
};

const actions = {
  get: ({ commit }, { object_t, object_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/comment", {
          params: {
            objectId: object_id,
            objectT: object_t
          }
        })
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          commit("add_to_db_comments", {
            objectId: object_id,
            data: resp.data
          });
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  create: ({ commit }, { comment }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .post("/api/comment/add", comment)
        .then((resp) => {
          commit("success");
          commit("pushItem", {
            objectId: comment.ObjectId,
            data: resp.data
          });
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  add_like: ({ commit }, { comment_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/comment/addlike", {
          params: {
            id: comment_id
          }
        })
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  remove_like: ({ commit }, { comment_id }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/comment/removelike", {
          params: {
            id: comment_id
          }
        })
        .then((resp) => {
          commit("success");
          resolve(resp);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  pushItem: (state, payload) => {
    try {
      state.db_comments[payload.objectId].push(payload.data);
    } catch (error) {
      state.db_comments[payload.objectId] = payload.data;
    }
  },
  add_to_db_comments: (state, payload) => {
    state.db_comments[payload.objectId] = payload.data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
